import { getIDFromUrl, ID } from '@rossum/api-client';
import { Skeleton, Stack, Typography } from '@rossum/ui/material';
import { Url } from '../../types/basic';
import { useQueueWithWorkspace } from '../queues/hooks/useQueueWithWorkspace';

const QueueAndWorkspace = ({ queueId }: { queueId: ID }) => {
  const { queue, workspace, queueIsLoading, workspaceIsLoading } =
    useQueueWithWorkspace({ queueId });

  return queueIsLoading || workspaceIsLoading ? (
    <Skeleton sx={{ minWidth: '100px' }} />
  ) : (
    <span>
      {workspace?.name} - {queue?.name}
    </span>
  );
};

export const FilenameWorkspaceQueueInfo = ({
  filename,
  queueUrl,
}: {
  filename: string | null;
  queueUrl: Url | null;
}) => {
  return (
    <Stack
      direction="row"
      spacing={1}
      divider={
        <Typography variant="caption" color="text.disabled">
          |
        </Typography>
      }
    >
      <Typography
        variant="caption"
        color="text.primary"
        sx={{ wordBreak: 'break-word' }}
      >
        {filename ? <span>{filename}</span> : null}
      </Typography>
      <Typography variant="caption" color="text.primary">
        {queueUrl ? (
          <QueueAndWorkspace queueId={getIDFromUrl(queueUrl)} />
        ) : null}
      </Typography>
    </Stack>
  );
};
